<template>
  <div class='page-start'>
    <mdb-container class="col-10 pb-3" fluid>

      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
          Success! Submitted IT Change Request!
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
          There was an error submitting the IT Change Request. Please try again! Error Code P2
      </mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6" @closeAlert="p6=false" dismiss>
				There was an error retrieving data from the server! Please try again later.
			</mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="missingFields" @closeAlert="missingFields=false" dismiss>
				Missing required fields.
			</mdb-alert>

      <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">ITCR Submission Form</h3>
        <mdb-card-body>
          <form @submit.prevent="" class="was-validated">
            <mdb-row>
              <mdb-col>
                <mdb-input class="mb-3" v-model="author" label="Author" placeholder="Your Name" disabled/>
              </mdb-col>
            </mdb-row>
            <br>

            <mdb-row>
              <mdb-col>
                <mdb-select label="Type" @getValue="setType" v-model="itcrTypeOptions"/>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col>
                <div v-if="!itcrType" class="invalid-feedback d-block">Please select an option.</div>
                <div v-else class="valid-feedback d-block">Looks Good!</div>
              </mdb-col>
            </mdb-row>

            <br>
            <mdb-row>
              <mdb-col>
                <mdb-input type="textarea" :rows="4" outline class="mb-3" v-model="changeDescription" 
                label="Description" placeholder="Change to be implemented" invalid-feedback="Please Input ITCR Description" 
                valid-feedback="Looks Good!" maxlength="500" required/>
              </mdb-col>
            </mdb-row>
            <br>
           
            <mdb-row>
              <mdb-col>
                <mdb-input type="textarea" :rows="6" outline class="mb-3" v-model="additionalNotes" label="Additional Notes" placeholder="Notes" maxlength="5000" />
              </mdb-col>
            </mdb-row>

            <br>
            <mdb-btn class='QuadrusButton' v-on:click="submitITCR" type="submit" v-if="!submitProcessing">Submit</mdb-btn>
            <mdb-btn class='QuadrusButton' v-if="submitProcessing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Processing...
            </mdb-btn>

            <br>
            <mdb-btn color="danger" v-on:click="clearITCRForm">Clear</mdb-btn>
          </form>
        </mdb-card-body>
      </mdb-card>
    </mdb-container>
  </div>
</template>

<script>
import { mdbInput, mdbCard, mdbCardBody, mdbContainer, mdbBtn, mdbCol, mdbRow, mdbAlert, mdbSelect } from 'mdbvue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: 'ITCRForm',
	components: {
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbContainer,
    mdbBtn,
    mdbCol, 
    mdbRow,
    mdbAlert,
    mdbSelect
	},
  data() {
    return {

      p1: false,
      p2: false,
      p6: false,
      missingFields: false,

      changeDescription: "",
      author: "",
      additionalNotes: "",
      itcrType: "",

      itcrTypeOptions: [{text: "System", value: "System"},{text: "Facility", value: "Facility"}],
      submitProcessing: false,
    }
  },
  methods: {

    clearITCRForm: function() {
      this.changeDescription = "";     
      this.additionalNotes = "";
      this.itcrType = "";
      this.itcrTypeOptions = [{text: "System", value: "System"},{text: "Facility", value: "Facility"}];
    },

    setType: function(type) {
      this.itcrType = type;
    },


    getLoggedInUser: async function () {
      let token = this.$store.getters.getToken;      
      try 
			{
				let response = await DatabaseLib.getRequest('strapiDatabase','users/me',token);
				this.author = response.data.firstName + " " + response.data.lastName;
			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p6 = true;
				return;
			}
    },

    submitITCR: async function() {
      this.submitProcessing = true;
      let token = this.$store.getters.getToken;

      this.changeDescription = sanitizeInput(this.changeDescription, this.$sanitize);
      await this.getLoggedInUser();
      this.additionalNotes = sanitizeInput(this.additionalNotes, this.$sanitize);
      this.itcrType = sanitizeInput(this.itcrType, this.$sanitize);
      const utcTimestamp = new Date().toISOString();
      
      let data = {
        data: {
          submitter: this.author,
          submitDate: utcTimestamp,
          changeDescription: this.changeDescription,
          additionalNotes: this.additionalNotes,
          stage: "SIA",
          itcrType: this.itcrType
        }
      }
      if(this.changeDescription != '' && this.author != '' && this.itcrType != ''){
        try {
          await DatabaseLib.postRequest('strapiDatabase','itcrs',token,data);
          this.p1 = true;
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p2 = true;
          this.submitProcessing = false;
          return;
        }
        this.clearITCRForm();
      } else {
        this.missingFields = true;
      }
      this.submitProcessing = false;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    
  }, 
 
  mounted(){
    this.getLoggedInUser();
  }
}
</script>